export default "__VITE_ASSET__CYXNvr1M__"